<template>
  <page-wrapper
    ref="pageEl"
    :title="'รายงาน'"
    :is-job-list-page="true"
    :show-filter-result="searchResultCount"
    @showMobileNavBar="showMobileNavBar"
    @showMobileFilter="showMobileFilter"
  >
    <!-- Mobile filter dialog -->
    <div v-if="isShowMobileFilterDialog" class="dialog-bg">
      <div class="dialog-box">
        <div class="header">
          <p>{{ "ตัวกรอง" }}</p>
          <div class="close-btn" @click="hideMobileFilter">
            <i class="fa fa-times"></i>
          </div>
        </div>
        <div class="content">
          <search-form
            :project-results="projectResults"
            @searchSubmit="handleSearchSubmit"
          ></search-form>
        </div>
      </div>
    </div>
    <!-- Desktop filter -->
    <search-form
      v-if="isDesktop"
      :project-results="projectResults"
      @searchSubmit="handleSearchSubmit"
    ></search-form>
    <div class="total-count-wrapper">
      <p v-if="total" class="total-count">{{ totalCount }}</p>
      <button
        v-if="!noResult"
        :disabled="!isClickDownloadAppointmentReport"
        class="download-button"
        @click.prevent="handleClickDownloadAppointmentReports"
      >
        ดาวน์โหลดรายงาน
      </button>
    </div>
    <div v-if="noResult && !loader" class="p-4 text-center">ไม่มีข้อมูล</div>
    <div v-if="!noResult" class="report-list-wrapper">
      <!-- Report list header -->
      <div class="header">
        <div class="item">สถานะ</div>
        <div class="item">ครั้งที่</div>
        <div class="item">ชื่อบริการ</div>
        <div class="item">ลูกค้า</div>
        <div class="item">นัดหมาย</div>
        <div class="item">หมายเหตุลูกค้า</div>
      </div>
      <!-- Report list -->
      <div v-for="job in jobResults" :key="job.id">
        <report-list-item :job="job"></report-list-item>
      </div>
    </div>
    <!-- Report list pagination -->
    <div v-if="!noResult" class="text-center mt-4">
      <el-pagination
        :pager-count="5"
        :total="total"
        :page-size="10"
        :current-page="queryParams.page"
        background
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </page-wrapper>
</template>

<script>
import { Pagination } from "element-ui"
import { baanRueJaiClient } from "@/dependencies"
import PageWrapper from "../components/SupplierPageWrapper"
import SearchForm from "../components/SearchForm"
import ReportListItem from "../components/ReportListItem"
import { mSize } from "../StaticVariable"
import { stringToJson } from "../../lib/jsonFormatter"

export default {
  components: {
    PageWrapper,
    SearchForm,
    ReportListItem,
    "el-pagination": Pagination,
  },
  data() {
    const providerId = localStorage.getItem("supplierProviderId")
    const filter = {
      providerId: null,
      page: null,
      dateTime: null,
      project: null,
      home: null,
      status: null,
      user: null,
    }

    return {
      windowWidth: window.innerWidth,
      showMobileFilterDialog: false,
      providerId,
      filter,
      total: 0,
      searchResultCount: 0,
      jobResults: [],
      projectResults: [],
      isClickDownloadAppointmentReport: true,
    }
  },
  computed: {
    loader() {
      return this.$store.state.loader
    },
    isDesktop() {
      return this.windowWidth >= mSize
    },
    navigationMenu() {
      return this.$route.params.navigationMenu
    },
    isShowMobileFilterDialog() {
      return this.showMobileFilterDialog
    },
    totalCount() {
      const total = this.total ? this.total.toLocaleString() : 0

      return `ทั้งหมด ${total} รายการ`
    },
    noResult() {
      return this.jobResults.length === 0
    },
    queryParams() {
      const query = {}

      const { providerId, page, dateTime, project, home, status, user } =
        this.filter

      if (providerId) {
        query.providerId = providerId
      }

      if (page) {
        query.page = page
      }

      if (dateTime) {
        query.dateTime = stringToJson(dateTime)
      }

      if (project) {
        query.projectId = stringToJson(project).id
      }

      if (home) {
        query.homeId = stringToJson(home).id
      }

      if (status) {
        query.status = stringToJson(status).id
      }

      if (user) {
        query.userId = stringToJson(user).id
      }

      return query
    },
  },
  watch: {
    "$route.query": async function routeQueryWatcher() {
      this.setupQuery()
      await this.setupData()

      this.$refs.pageEl.$el.querySelector(".page-content").scrollTop = 0
    },
  },
  created() {
    this.setup()
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize)
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth

      if (this.isDesktop) {
        this.hideMobileFilter()
      }
    },
    setup() {
      this.setupQuery()
      this.setupData()
    },
    setupQuery() {
      this.filter = {
        providerId: this.providerId,
        page: parseInt(this.$route.query.page, 10) || 1,
        dateTime: this.$route.query.dateTime,
        project: this.$route.query.project,
        home: this.$route.query.home,
        status: this.$route.query.status,
        user: this.$route.query.user,
      }
    },
    async setupData() {
      this.setupSearchResult()
      await this.setupReportList()
      await this.setupProjects()
    },
    setupSearchResult() {
      this.searchResultCount = this.getSearchResultCount()
    },
    async setupReportList() {
      try {
        const params = this.queryParams

        const appointment = await this.fetchReportList(params)

        this.total = appointment.count
        this.jobResults = appointment.appointments
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err)
      }
    },
    async fetchReportList(params) {
      return baanRueJaiClient.others.supplier.getProviderReportList(params)
    },
    async setupProjects() {
      const projects = await this.fetchProjects()

      this.projectResults = projects
    },
    async fetchProjects() {
      return baanRueJaiClient.others.supplier.getReportProjects()
    },
    showMobileNavBar() {
      this.$emit("showMobileNavBar")
    },
    showMobileFilter() {
      this.showMobileFilterDialog = true
    },
    hideMobileFilter() {
      this.showMobileFilterDialog = false
    },
    handleCurrentChange(page) {
      const route = {
        name: this.$route.name,
        query: { ...this.$route.query, page },
      }

      this.$router.replace(route)
    },
    handleSearchSubmit(filter) {
      this.hideMobileFilter()

      const query = {}

      const { dateTime, project, home, status, user } = filter

      if (dateTime) {
        query.dateTime = dateTime
      }

      if (project) {
        query.project = project
      }

      if (home) {
        query.home = home
      }

      if (status) {
        query.status = status
      }

      if (user) {
        query.user = user
      }

      const route = {
        name: this.$route.name,
        query: { ...query },
      }

      this.$router.replace(route)
    },
    getSearchResultCount() {
      const results = {}

      const { project, home, status, user, dateTime } = this.filter

      if (project) {
        results.project = true
      }

      if (home) {
        results.home = true
      }

      if (status) {
        results.status = true
      }

      if (user) {
        results.user = true
      }

      if (dateTime) {
        const dateTomeJSON = stringToJson(dateTime)
        results.dateFrom = true

        if (dateTomeJSON.hasDateTo) {
          results.dateTo = true
        }
      }

      return Object.values(results).length
    },
    async handleClickDownloadAppointmentReports(event) {
      event.preventDefault()
      this.isDisableButton()

      const response =
        await baanRueJaiClient.others.supplier.getProviderReportList({
          ...this.queryParams,
          format: "xlsx",
        })

      const blob = new Blob([response])
      const link = document.createElement("a")
      link.href = window.URL.createObjectURL(blob)
      link.download = `appointment-reports.xlsx`
      link.click()

      this.isEnableButton()
    },
    isDisableButton() {
      this.isClickDownloadAppointmentReport = false
    },
    isEnableButton() {
      this.isClickDownloadAppointmentReport = true
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables";
.dialog-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;

  > .dialog-box {
    background-color: $white;
    border-radius: 8px;
    width: 320px;
    max-height: 100%;
    overflow-y: auto;

    > .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: $supplier-primary-color;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;

      p {
        padding-inline: 16px;
        padding-block: 8px;
        font-size: $font-18;
        font-weight: bold;
        color: $white;
      }

      > .close-btn {
        padding-inline: 16px;
        padding-block: 8px;
        color: $white;
        cursor: pointer;

        &:hover:not(:disabled) {
          opacity: 0.7;
        }
      }
    }

    > .content {
      display: flex;
      flex-direction: column;
    }
  }
}

.total-count-wrapper {
  padding-inline: 24px;
  padding-bottom: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;

  > .total-count {
    font-size: $font-14;
    margin-right: auto;
  }

  > .download-button {
    margin-left: auto;
    margin-left: 24px;
    width: 150px;
    height: 40px;
    font-size: $font-14;
    font-weight: bold;
    align-items: center;
    border: 1px solid $color-light-gray-1;
    border-radius: 8px;
    color: $black;
    background: transparent;

    &:hover:not(:disabled) {
      background: $color-light-gray-1-hover;
    }
  }

  .download-button:disabled {
    color: #c4c4c4;
    background: #e6e6e6;
    cursor: not-allowed;
  }
}

.report-list-wrapper {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  overflow-x: auto;

  > .header {
    position: sticky;
    top: 0;
    display: grid;
    width: max-content;
    grid-template-columns: 130px 100px 250px 170px 280px 220px;
    grid-gap: 16px;
    border-bottom: 4px solid $color-light-gray-1;
    padding: 12px 24px;
    background-color: $color-background;

    > .item {
      font-size: 16px;
      color: $color-gray;
    }
  }
}

@media (max-width: ($m-size - 1)) {
  .total-count-wrapper {
    padding-block: 16px;
  }

  .report-list-wrapper {
    > .header {
      border-bottom: 2px solid $color-light-gray-1;
    }
  }
}

@media (min-width: $m-size) and (max-width: ($ml-size - 1)) {
  .report-list-wrapper {
    > .header {
      border-bottom: 2px solid $color-light-gray-1;
    }
  }
}

@media (min-width: $ml-size) and (max-width: ($l-size - 1)) {
  .report-list-wrapper {
    > .header {
      border-bottom: 3px solid $color-light-gray-1;
    }
  }
}
</style>
